import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "hidevalueifzero",
})
export class HidevalueifzeroPipe implements PipeTransform {
  transform(num: number | null): string {
    if (num === 0 || num === 0.0 || num === null || num === undefined) {
      return "";
    } else {
      return num.toString();
    }
  }
}
